import { useState, useEffect } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import "./Checkout.css";
import "react-calendar/dist/Calendar.css";
import Calendar from "react-calendar";
import ApiService from "../../components/Api_services";
import { STAFF_PURCHASE_ID, CASH_ACCOUNT } from "../../constants";
import Loading from "../../components/loading/Loading";
import FallbackImg from "../../components/FallbackImg";
import EInvoiceModal from "../../components/einvoice/EInvoiceModal";
import CheckoutBranch from "../../components/checkoutbranch_v2/CheckoutBranch";
// import ReactDOM from "react-dom";
import CustomDropdown from "../../components/customdropdown_v2/CustomDropdown";
import BranchDropdownOption from "../../components/tooltipportal_v2/BranchDropdownOption";
import {
  ArrowLeft,
  MapPin,
  ChevronDown,
  Gift,
  Tag,
  Package,
  Calendar as CalendarIcon,
  X,
} from "lucide-react";
import MultiPurpose from "../../components/multipurpose_v2/MultiPurpose";
import Breadcrums from "../../components/breadcrums_v2/Breadcrums";

const Checkoutv2 = () => {
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [checkoutData, setCheckoutData] = useState(null);
  const [pricingType, setPricingType] = useState(null);
  const [selectedItems, setSelectedItems] = useState("");
  const [selectedCsIds, setSelectedCsIds] = useState("");
  const [checkoutMessage, setCheckoutMessage] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const tabParam = queryParams.get("pricingtype");
  const shouldUseTermsDirectly = tabParam !== "1";
  const [customerPO, setCustomerPO] = useState("");
  const [specifiedShippingDate, setSpecifiedShippingDate] = useState("");
  const [isShippingDateSpecified, setIsShippingDateSpecified] = useState(false);
  const [hasSalesmanId, setHasSalesmanId] = useState(false);
  const [orderInfo, setOrderInfo] = useState({
    orderId: "",
    message: "",
  });
  const [showOrderSuccess, setShowOrderSuccess] = useState(false);
  const [isCombineDO, setIsCombineDO] = useState(false);
  const mainid = localStorage.getItem("main_id");
  const isStaffPurchase = mainid == STAFF_PURCHASE_ID;
  const [staffList, setStaffList] = useState([]);
  const [orderBy, setOrderBy] = useState("");
  const salesmanId = localStorage.getItem("salesman_id");
  const [selectedStaffId, setSelectedStaffId] = useState("");
  const [selectedStaffName, setSelectedStaffName] = useState("");
  const [shippingType, setShippingType] = useState("normal_shipping");
  const [showEInvoiceModal, setShowEInvoiceModal] = useState(false);
  const [einvoiceErrors, setEinvoiceErrors] = useState({});
  const [showCashEinvoicePrompt, setShowCashEinvoicePrompt] = useState(false);
  const cartItems = location.state?.cartItems;
  const [selectedBranch, setSelectedBranch] = useState("");
  const [showCheckoutBranch, setShowCheckoutBranch] = useState(false);
  const [selectedBranchData, setSelectedBranchData] = useState(null);
  const [cartData, setCartData] = useState(null);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [showBranchDropdown, setShowBranchDropdown] = useState(false);
  const [branchSpecialDates, setBranchSpecialDates] = useState({});
  const [branchSpecialEnabled, setBranchSpecialEnabled] = useState({});
  const [showFastPayCheckoutBtn, setShowFastPayCheckoutBtn] = useState(false);
  const [activeBranchItemId, setActiveBranchItemId] = useState(null);
  const [activePromoItemId, setActivePromoItemId] = useState(null);
  const [branchSpecialPointEnabled, setBranchSpecialPointEnabled] = useState(
    {},
  );
  const [branchSpecialPointData, setBranchSpecialPointData] = useState({});
  const [showSpError, setShowSpError] = useState(false);
  const [spErrorMsg, setSpErrorMsg] = useState("");
  const [showSupplierError, setShowSupplierError] = useState(false);
  const [supplierErrorMsg, setSupplierErrorMsg] = useState("");
  const [showMultiPurpose, setShowMultiPurpose] = useState(false);
  const [multiPurposeType, setMultiPurposeType] = useState("");
  const [multiPurposeMsg, setMultiPurposeMsg] = useState("");
  const [showSalesmanConfirm, setShowSalesmanConfirm] = useState(false);
  const customerName = localStorage.getItem("real_company_name") || "";
  const [calendarOpen, setCalendarOpen] = useState(false);
  const [po_date, setCustomerPODate] = useState(null);
  const [showCheckoutError, setShowCheckoutError] = useState(false);
  const [checkoutErrorMsg, setCheckoutErrorMsg] = useState("");

  const hasShippingFeeOrEastMalaysia = Array.isArray(
    checkoutData?.branch_shipping_detail,
  )
    ? checkoutData.branch_shipping_detail.some(
        (d) => !d.is_free_shipping || d.is_east_malaysia,
      )
    : false;

  useEffect(() => {
    // Check for salesman_id in token
    const checkSalesmanId = () => {
      setHasSalesmanId(!!salesmanId && salesmanId.trim() !== "");
    };

    checkSalesmanId();
    const cartIdsParam = queryParams.get("cart_ids");
    const csIdsParam = queryParams.get("cs_ids");
    // const pricingTypeParam = queryParams.get("pricing_type");

    setSelectedItems(cartIdsParam || "");
    setSelectedCsIds(csIdsParam || "");
    // setPricingType(pricingTypeParam);
    setPricingType(tabParam || "");

    if (!cartIdsParam && !csIdsParam) {
      setError("No items selected for checkout");
      setLoading(false);
      return;
    }

    fetchCheckoutData(
      cartIdsParam || "",
      tabParam,
      salesmanId,
      csIdsParam || "",
    );

    fetchCartData("1", tabParam, "", cartIdsParam || "", csIdsParam || "");

    // 只有 staff purchase 才 fetch staff list
    if (mainid == STAFF_PURCHASE_ID) {
      fetchStaffList(salesmanId);
    }
  }, [location]);

  // Prompt will be shown when user clicks the checkout button for CASH account.

  const processCartItems = (cartItems) => {
    if (!cartItems || !Array.isArray(cartItems)) return [];

    const itemGroups = {};

    cartItems.forEach((item) => {
      // Package items: keep each as its own row (don't merge by item_id)
      // const key =
      //   item.is_package === 1
      //     ? `pkg_${item.id}`
      //     : `${item.item_id}_${item.is_foc}}`;
      let key;
      if (item.is_package === 1) {
        key = `pkg_${item.id}`;
      } else if (item.quotation_id && item.quotation_id !== "") {
        // Quotation items — always keep as separate row per cart id
        key = `quotation_${item.id}`;
      } else if (item.is_support_item) {
        key = `support_${item.id}`;
      } else {
        key = `${item.item_id}_${item.is_foc}`;
      }

      if (!itemGroups[key]) {
        itemGroups[key] = {
          ...item,
          originalIds: [item.id],
        };
      } else {
        if (!itemGroups[key].originalIds.includes(item.id)) {
          itemGroups[key].originalIds.push(item.id);
        }
      }
    });

    return Object.values(itemGroups);
  };

  const fetchCartData = async (
    page = 1,
    activeTab,
    searchTerm = "",
    cartId,
    csIds,
  ) => {
    setLoading(true);
    try {
      const response = await ApiService.getMyCart(
        page,
        activeTab,
        999999,
        searchTerm,
        cartId,
        csIds,
      );

      // console.log("API response for getMyCartCheckout:", response);

      if (response.status === 200) {
        if (response.data?.results?.cart) {
          // Group items by item_id
          const processedItems = processCartItems(response.data.results.cart);

          // PRECOMPUTE branch data for each item
          const processedWithBranchData = processedItems.map((item) => {
            const promoTags = getPromotionTags([
              item,
              ...(item.children || []),
            ]);
            const promotionTypes = promoTags.map((tag) => tag.type);
            const offerTypes = promoTags.map((tag) => tag.offerType);

            const branchesToRender = [];

            // Find all Buy X Free Y tags (type 4)
            const buyXFreeYTags = promoTags.filter(
              (tag) => tag.type === 4 && tag.offerType === "0",
            );
            // Find all Buy X Discount Y tags (type 4)
            const buyXDiscountYTags = promoTags.filter(
              (tag) => tag.type === 4 && tag.offerType === "1",
            );
            // Find the best matching Buy X Free Y offer for the main item quantity
            let buyXFreeYTag = null;
            if (
              buyXFreeYTags.length > 0 &&
              item.cargo_dist &&
              item.cargo_dist.length > 0
            ) {
              const totalQty = item.cargo_dist.reduce(
                (sum, branch) => sum + Number(branch.quantity || 0),
                0,
              );
              buyXFreeYTag =
                buyXFreeYTags
                  .filter((tag) => Number(tag.order) <= totalQty)
                  .sort((a, b) => Number(b.order) - Number(a.order))[0] ||
                buyXFreeYTags[0];
            }
            // Find the best matching Buy X Discount Y offer for the main item quantity
            let buyXDiscountYTag = null;
            if (
              buyXDiscountYTags.length > 0 &&
              item.cargo_dist &&
              item.cargo_dist.length > 0
            ) {
              const totalQty = item.cargo_dist.reduce(
                (sum, branch) => sum + Number(branch.quantity || 0),
                0,
              );
              buyXDiscountYTag =
                buyXDiscountYTags
                  .filter((tag) => Number(tag.order) <= totalQty)
                  .sort((a, b) => Number(b.order) - Number(a.order))[0] ||
                buyXDiscountYTags[0];
            }
            const itemDiscountTag = promoTags.find((tag) => tag.type === 3);
            const pwpTag = promoTags.find((tag) => tag.type === 5);
            const displayDiscountTag = promoTags.find((tag) => tag.type === 6);

            // Main item branches
            if (item.cargo_dist && item.cargo_dist.length > 0) {
              item.cargo_dist.forEach((branch) => {
                let promoType = "No Promotion";
                let promoIcon = null;

                if (buyXFreeYTag) {
                  promoType = buyXFreeYTag.label;
                  promoIcon = buyXFreeYTag.icon;
                } else if (buyXDiscountYTag) {
                  promoType = buyXDiscountYTag.label;
                  promoIcon = buyXDiscountYTag.icon;
                } else if (itemDiscountTag) {
                  promoType = itemDiscountTag.label;
                  promoIcon = itemDiscountTag.icon;
                } else if (pwpTag) {
                  promoType = pwpTag.label;
                  promoIcon = pwpTag.icon;
                } else if (displayDiscountTag) {
                  promoType = displayDiscountTag.label;
                  promoIcon = displayDiscountTag.icon;
                }

                branchesToRender.push({
                  branch_id: branch.branch_id ?? 0,
                  branch_code: branch.branch_code,
                  quantity: branch.quantity,
                  itemName: item.item_name,
                  itemCode: item.item_code,
                  itemPrice: item.price,
                  promoType,
                  promoIcon,
                  isFree: false,
                  isChild: false,
                });
              });
            }

            // Children branches (always free gift)
            (item.children || []).forEach((child) => {
              let childTag;
              if (child.promotion_type === "4" && child.quantity_offer_id) {
                childTag = promoTags.find(
                  (tag) =>
                    tag.id ===
                    `${child.promotion_id}_${child.quantity_offer_id}`,
                );
              } else if (child.promotion_type === "5") {
                childTag = promoTags.find((tag) => tag.type === 5);
              } else if (child.promotion_type === "6") {
                childTag = promoTags.find((tag) => tag.type === 6);
              } else if (child.promotion_type === "2") {
                childTag = promoTags.find((tag) => tag.type === 2);
              } else {
                childTag = promoTags.find(
                  (tag) => tag.id === child.promotion_id,
                );
              }

              (child.cargo_dist || []).forEach((branch) => {
                branchesToRender.push({
                  branch_id: branch.branch_id ?? 0,
                  branch_code: branch.branch_code,
                  quantity: branch.quantity,
                  itemName: child.item_name,
                  itemCode: child.item_code,
                  itemPrice: child.price,
                  promoType: childTag ? childTag.label : "Promotion",
                  promoIcon: childTag ? childTag.icon : null,
                  isFree: child.promotion_type === "2",
                  isChild: true,
                });
              });
            });

            // Return the item with precomputed branch data
            return {
              ...item,
              branchData: [...branchesToRender].sort(
                (a, b) => Number(a.branch_id) - Number(b.branch_id),
              ),
              promotionTypes,
              offerTypes,
            };
          });

          setCartData({
            ...response.data.results,
            cart: processedWithBranchData,
          });
        } else {
          setCartData(response.data?.results || null);
        }

        setTotalItems(response.data?.results?.total_item || 0);

        if (response.data?.pagination) {
          setTotalPages(response.data.pagination.total_pages || 1);
          setCurrentPage(response.data.pagination.current_page || 1);
        } else {
          setTotalPages(1);
        }
      } else {
        setError(response.message || "Failed to fetch cart data");
      }
    } catch (err) {
      console.error("Error loading cart:", err);
      setError("Error loading cart data");
    } finally {
      setLoading(false);
    }
  };

  const fetchCheckoutData = async (
    selectedItems,
    activeTab,
    salesmanId,
    selectedCsIds,
  ) => {
    try {
      setLoading(true);

      // console.log("Selected Items:", selectedItems); // Log selectedItems
      // console.log("Salesman ID:", salesmanId); // Log salesmanId

      const response = await ApiService.getCheckoutDetail(
        selectedItems,
        activeTab,
        salesmanId,
        selectedCsIds,
      );

      // console.log("Checkout API response:", response);

      if (response.status === 200) {
        setCheckoutData(response.data || null);
      } else {
        setError(response.message || "Failed to fetch checkout data");
      }
    } catch (err) {
      console.error("Error loading checkout:", err);
      setError("Error loading checkout data");
    } finally {
      setLoading(false);
    }
  };

  const fetchStaffList = async (salesmanId) => {
    try {
      setLoading(true);
      const response = await ApiService.getStaffList(salesmanId);
      if (response.status === 200) {
        setOrderBy(response.data.order_by || "");
        setStaffList(response.data.staff_list || []);
      } else {
        console.error("Failed to fetch staff list:", response.message);
      }
    } catch (err) {
      console.error("Error fetching staff list:", err);
      setError("Error fetching staff list");
    } finally {
      setLoading(false);
    }
  };

  const handleSelectPayment = (value) => {
    setSelectedPayment(selectedPayment === value ? null : value);
    setShowCheckoutError(false);
  };

  const doCheckout = async (extraEinvoiceData = null) => {
    setSubmitting(true);

    // ── Special Point validation ──
    const customerHasSpecialPoint = String(checkoutData?.special_point) === "1";
    if (
      hasSalesmanId &&
      customerHasSpecialPoint &&
      Array.isArray(checkoutData?.items_by_branch)
    ) {
      for (const branch of checkoutData.items_by_branch) {
        const code = branch.branch_code;
        if (branchSpecialPointEnabled[code]) {
          const sp = branchSpecialPointData[code];
          const missingFields = [];
          if (!sp?.sp_name) missingFields.push("Receiver Name");
          if (!sp?.sp_phone) missingFields.push("Receiver Phone");
          if (!sp?.sp_addr) missingFields.push("Address");
          if (!sp?.sp_state) missingFields.push("State");
          if (!sp?.sp_city) missingFields.push("City");
          if (!sp?.sp_postcode) missingFields.push("Postcode");

          if (missingFields.length > 0) {
            setSpErrorMsg(
              `Branch ${code} - Special Point: Please fill in ${missingFields.join(", ")}.`,
            );
            setShowSpError(true);
            setSubmitting(false);
            return;
          }
        }
      }
    }
    // ── End Special Point validation ──

    try {
      // ...准备参数
      const paymentType = shouldUseTermsDirectly
        ? "terms"
        : selectedPayment === "Unity Pay Later"
          ? "terms"
          : "pay_later";
      const pricingType = tabParam;

      const salesmanOpt = hasSalesmanId
        ? {
            staff_id_val: selectedStaffId,
            staff_name_val: selectedStaffName,
            customer_po_val: customerPO,
            customer_do_val: isCombineDO ? "1" : "0",
            ordered_by: salesmanId,
          }
        : null;

      const option =
        hasSalesmanId && checkoutData.items_by_branch?.length > 0
          ? checkoutData.items_by_branch.map((branch) => ({
              branch_id: branch.branch_id,
              stc: shippingType === "supplier_to_customer" ? 1 : 0,
              own_delivery: shippingType === "own_pickup" ? 1 : 0,
              special_point: branchSpecialPointData[branch.branch_code] ? 1 : 0,
              special_date: branchSpecialDates[branch.branch_code] ? 1 : 0,
              special_date_info: branchSpecialDates[branch.branch_code]
                ? new Date(branchSpecialDates[branch.branch_code])
                    .toLocaleDateString("en-MY")
                    .split("/")
                    .reverse()
                    .join("-")
                : "",
              no_shipping: 0,
              special_point_addr: {
                name: branchSpecialPointData[branch.branch_code]?.sp_name || "",
                phone:
                  branchSpecialPointData[branch.branch_code]?.sp_phone || "",
                addr: branchSpecialPointData[branch.branch_code]?.sp_addr || "",
                state:
                  branchSpecialPointData[branch.branch_code]?.sp_state || "",
                city: branchSpecialPointData[branch.branch_code]?.sp_city || "",
                postcode:
                  branchSpecialPointData[branch.branch_code]?.sp_postcode || "",
              },
            }))
          : null;

      const einvoicePayload = einvoiceFilled ? extraEinvoiceData : null;

      const response = await ApiService.processCheckout(
        selectedItems ? selectedItems : "",
        paymentType,
        pricingType,
        checkoutMessage,
        customerPO,
        po_date
          ? new Date(po_date)
              .toLocaleDateString("en-MY")
              .split("/")
              .reverse()
              .join("-")
          : null,
        isShippingDateSpecified ? specifiedShippingDate : null,
        salesmanOpt,
        option,
        einvoicePayload,
        selectedCsIds,
        tinNo || "",
      );

      if (response.status === 200) {
        // setShowOrderSuccess(true);
        setOrderInfo({
          orderId: response.data.order_id,
          message: response.data.msg,
          paymentType: paymentType,
        });
        window.scrollTo(0, 0);
        navigate("/allorder");
      } else if (
        response.status === 403 ||
        response.data?.type === "overdue" ||
        response.data?.type === "credit_limit"
      ) {
        setMultiPurposeType(response.data?.type || "credit_limit");
        setShowMultiPurpose(true);
      } else {
        const errorMsg = response.message || "Failed to process checkout";

        setCheckoutErrorMsg(errorMsg);
        setShowCheckoutError(true);
        window.scrollTo(0, 0);
      }
    } catch (err) {
      setCheckoutErrorMsg("Error processing your order. Please try again.");
      setShowCheckoutError(true);
    } finally {
      setSubmitting(false);
    }
  };

  const getMultiPurposeContent = () => {
    if (multiPurposeType === "credit_limit") {
      return (
        <div>
          <span style={{ color: "red" }}>*OVER CREDIT LIMIT*</span>
          <br />
          <br />
          Hey dear customer,
          <br />
          <br />
          Thank you for placing your order with us.
          <br />
          <br />
          Unfortunately, you've exceeded your credit limit (including this
          order).
          <br />
          <br />
          You may take either of the actions as follow :<br />
          1. Clear out all of your outstanding balance
          <br />
          2. Edit your order
          <br />
          3. Request credit limit increase
          <br />
        </div>
      );
    }
    if (multiPurposeType === "overdue") {
      return (
        <div>
          <span style={{ color: "red" }}>*OVERDUE*</span>
          <br />
          <br />
          Hey dear customer,
          <br />
          <br />
          Thank you for placing your order with us.
          <br />
          <br />
          Based on our records, you have overdue invoice(s).
          <br />
          <br />
          Kindly make payment first before proceeding with checkout.
          <br />
          <br />
          Your cooperation is highly appreciated.
        </div>
      );
    }
    return null;
  };

  const [einvoiceData, setEinvoiceData] = useState({
    id_type: "1", // 默认身份证
    id_no: "",
    full_name: "",
    email: "",
    tel: "",
    address: "",
    city: "",
    state: "",
    postcode: "",
    country: "MYS", // 默认马来西亚
    tin_no: "",
  });

  const validateEinvoice = (data) => {
    const errors = {};
    if (!data.id_type) errors.id_type = "This field is required";
    if (!data.id_no) errors.id_no = "This field is required";
    if (!data.full_name) errors.full_name = "This field is required";
    if (!data.email) errors.email = "This field is required";
    if (!data.tel) errors.tel = "This field is required";
    if (!data.address) errors.address = "This field is required";
    if (!data.city) errors.city = "This field is required";
    if (!data.state) errors.state = "This field is required";
    if (!data.postcode) errors.postcode = "This field is required";
    if (!data.country) errors.country = "This field is required";
    if (!data.tin_no) errors.tin_no = "This field is required";
    return errors;
  };
  const [einvoiceFilled, setEinvoiceFilled] = useState(false);
  const [showTinPrompt, setShowTinPrompt] = useState(false);
  const [tinError, setTinError] = useState("");
  const [tinNo, setTinNo] = useState("");
  const [tinConfirmed, setTinConfirmed] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // If TIN status requires verification, prompt user to confirm/fill TIN
    // Only consider it confirmed when user clicks Confirm; closing does not confirm
    if (String(checkoutData?.tin_status) === "0" && !tinConfirmed) {
      setTinNo(checkoutData?.tin_no || "");
      setShowTinPrompt(true);
      return;
    }
    // 检查是否选择了支付方式
    if (!selectedPayment && !shouldUseTermsDirectly) {
      setCheckoutErrorMsg("Please select a payment method");
      setShowCheckoutError(true);
      return;
    }
    // If user is CASH account and hasn't filled e-invoice, prompt first
    const real = (localStorage.getItem("real_company_name") || "").trim();
    const cash = (CASH_ACCOUNT || "").trim();
    if (
      real &&
      cash &&
      real.toLowerCase() === cash.toLowerCase() &&
      !einvoiceFilled
    ) {
      setShowCashEinvoicePrompt(true);
      return;
    }
    // 检查是否需要并已填写 E-invoice 信息
    if (String(checkoutData.einvoice_data_require) === "1" && !einvoiceFilled) {
      setShowEInvoiceModal(true);
      return;
    }
    // Supplier to Customer shipping requires all selected items to share the same supplier
    if (shippingType === "supplier_to_customer") {
      setSubmitting(true);
      const supplierCheck = await ApiService.checkSameSupplier(
        selectedItems,
        selectedCsIds,
        tabParam,
        shippingType,
      );
      setSubmitting(false);
      if (supplierCheck.status !== 200) {
        setSupplierErrorMsg(
          supplierCheck.message ||
            "Selected items are from different suppliers. Supplier to Customer shipping requires all items to be from the same supplier.",
        );
        setShowSupplierError(true);
        return;
      }
    }
    // Continue with normal submit flow
    continueSubmitFlow();
  };

  const continueSubmitFlow = () => {
    if (hasSalesmanId && !showSalesmanConfirm) {
      setShowSalesmanConfirm(true);
      return;
    }

    if (selectedPayment === "FPX") {
      const fpxSalesmanOpt = hasSalesmanId
        ? {
            staff_id_val: selectedStaffId,
            staff_name_val: selectedStaffName,
            customer_po_val: customerPO,
            customer_do_val: isCombineDO ? "1" : "0",
            ordered_by: salesmanId,
          }
        : null;
      const fpxOption =
        hasSalesmanId && checkoutData.items_by_branch?.length > 0
          ? checkoutData.items_by_branch.map((branch) => ({
              branch_id: branch.branch_id,
              stc: shippingType === "supplier_to_customer" ? 1 : 0,
              own_delivery: shippingType === "own_pickup" ? 1 : 0,
              special_point: branchSpecialPointData[branch.branch_code] ? 1 : 0,
              special_date: branchSpecialDates[branch.branch_code] ? 1 : 0,
              special_date_info: branchSpecialDates[branch.branch_code]
                ? new Date(branchSpecialDates[branch.branch_code])
                    .toLocaleDateString("en-MY")
                    .split("/")
                    .reverse()
                    .join("-")
                : "",
              no_shipping: 0,
              special_point_addr: {
                name: branchSpecialPointData[branch.branch_code]?.sp_name || "",
                phone:
                  branchSpecialPointData[branch.branch_code]?.sp_phone || "",
                addr: branchSpecialPointData[branch.branch_code]?.sp_addr || "",
                state:
                  branchSpecialPointData[branch.branch_code]?.sp_state || "",
                city: branchSpecialPointData[branch.branch_code]?.sp_city || "",
                postcode:
                  branchSpecialPointData[branch.branch_code]?.sp_postcode || "",
              },
            }))
          : null;
      navigate(`/uploadcheque?cart_ids=${selectedItems}&type=fpx`, {
        state: {
          selectedItems,
          paymentType: "fpx",
          pricingType: tabParam,
          checkoutMessage,
          customerPO,
          specifiedShippingDate: isShippingDateSpecified
            ? specifiedShippingDate
            : null,
          ...(fpxSalesmanOpt && { salesmanOpt: fpxSalesmanOpt }),
          ...(fpxOption && { option: fpxOption }),
          ...(einvoiceFilled && { extraEinvoiceData: einvoiceData }),
          ...(tinNo && { tin_no: tinNo }),
        },
      });
      return;
    }
    doCheckout(einvoiceFilled ? einvoiceData : null);
  };

  const handleFastPayNavigate = () => {
    if (String(checkoutData.einvoice_data_require) === "1" && !einvoiceFilled) {
      setShowEInvoiceModal(true);
      return;
    }

    const fastPaySalesmanOpt = hasSalesmanId
      ? {
          staff_id_val: selectedStaffId,
          staff_name_val: selectedStaffName,
          customer_po_val: customerPO,
          customer_do_val: isCombineDO ? "1" : "0",
          ordered_by: salesmanId,
        }
      : null;
    const fastPayOption =
      hasSalesmanId && checkoutData.items_by_branch?.length > 0
        ? checkoutData.items_by_branch.map((branch) => ({
            branch_id: branch.branch_id,
            stc: shippingType === "supplier_to_customer" ? 1 : 0,
            own_delivery: shippingType === "own_pickup" ? 1 : 0,
            special_point: branchSpecialPointData[branch.branch_code] ? 1 : 0,
            special_date: branchSpecialDates[branch.branch_code] ? 1 : 0,
            special_date_info: branchSpecialDates[branch.branch_code]
              ? new Date(branchSpecialDates[branch.branch_code])
                  .toLocaleDateString("en-MY")
                  .split("/")
                  .reverse()
                  .join("-")
              : "",
            no_shipping: 0,
            special_point_addr: {
              name: branchSpecialPointData[branch.branch_code]?.sp_name || "",
              phone: branchSpecialPointData[branch.branch_code]?.sp_phone || "",
              addr: branchSpecialPointData[branch.branch_code]?.sp_addr || "",
              state: branchSpecialPointData[branch.branch_code]?.sp_state || "",
              city: branchSpecialPointData[branch.branch_code]?.sp_city || "",
              postcode:
                branchSpecialPointData[branch.branch_code]?.sp_postcode || "",
            },
          }))
        : null;
    navigate(`/uploadcheque?cart_ids=${selectedItems}&type=fpx&fastpay=1`, {
      state: {
        selectedItems,
        paymentType: "fpx",
        checkoutMessage,
        customerPO,
        specifiedShippingDate: isShippingDateSpecified
          ? specifiedShippingDate
          : null,
        ...(fastPaySalesmanOpt && { salesmanOpt: fastPaySalesmanOpt }),
        ...(fastPayOption && { option: fastPayOption }),
        ...(einvoiceFilled && { extraEinvoiceData: einvoiceData }),
        ...(tinNo && { tin_no: tinNo }),
      },
    });
  };

  // E-invoice 确认
  const handleEInvoiceConfirm = (e) => {
    e.preventDefault();
    const errors = validateEinvoice(einvoiceData);
    setEinvoiceErrors(errors);
    if (Object.keys(errors).length > 0) return;
    setShowEInvoiceModal(false);
    setEinvoiceFilled(true);
  };

  const formatCurrency = (value) => {
    return parseFloat(value).toLocaleString("en-MY", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const formatTotal = (value) => {
    // Convert negative values to zero or handle as needed for display
    const numValue = parseFloat(value);
    return formatCurrency(numValue < 0 ? 0 : numValue);
  };

  const handleShippingDateToggle = () => {
    setIsShippingDateSpecified(!isShippingDateSpecified);
    if (!isShippingDateSpecified) {
      // Set default date to tomorrow when enabling
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      setSpecifiedShippingDate(tomorrow.toISOString().split("T")[0]); // Format as YYYY-MM-DD
    }
  };

  // PWP addon rows store promotion_id (real promo FK) + pwp_promotion_id
  // (pwp_info sub id) split, like quantity_offer_id — rebuild the composite
  // "{promotion_id}_{sub_id}" tag id from them. Rows that already carry the
  // full composite in pwp_promotion_id (the main item row, or legacy data
  // inserted before the split) are returned as-is.
  function resolvePwpCompositeId(row) {
    if (!row) return null;
    const sub = row.pwp_promotion_id;
    // "0" is the backend's "no PWP sub id" marker on the main item row
    // (PHP's empty("0") is true) but "0" is a truthy string in JS — treat
    // it the same as missing/absent.
    if (!sub || sub === "0") return null;
    return String(sub).includes("_") ? sub : `${row.promotion_id}_${sub}`;
  }

  function getPromotionTags(promoDetail = []) {
    const tags = [];
    const seen = new Set();

    promoDetail.forEach((promo) => {
      const type = parseInt(promo.promotion_type);
      const promoName = promo.promo_name;

      // Free Gift (only free gift use promoName instead of type since the type sometimes wont be returning 2)
      if (promoName === "Free Gift" && promo.free_gift_id) {
        const tagId = `2_${promo.free_gift_id}`;
        if (!seen.has(tagId)) {
          tags.push({
            id: promo.free_gift_id,
            label: "Free Gift",
            type: 2,
            icon: <Gift size={14} />,
          });
          seen.add(tagId);
        }
      }

      // Item Discount
      if (type === 3 && promo.promotion_id) {
        const tagId = `3_${promo.promotion_id}`;
        if (!seen.has(tagId)) {
          tags.push({
            id: promo.promotion_id,
            label: "Item Discount",
            type: 3,
            icon: <Tag size={14} />,
          });
          seen.add(tagId);
        }
      }

      // Quantity Offer (Buy X Free Y or Buy X Discount Y)
      if (type === 4 && promo.quantity_offer_id) {
        const discountValue = parseFloat(promo.discount);
        const tagId = `4_${promo.promotion_id}_${promo.quantity_offer_id}`;
        if (!seen.has(tagId)) {
          if (discountValue > 0) {
            // Format promo_name: "Buy 4 Get 2.0000% Discount" -> "Buy 4 Discount 2%"
            let formattedPromoName = promo.promo_name.replace(
              /Buy (\d+) Get ([\d.]+)% Discount/,
              (match, buyQty, discount) =>
                `Buy ${buyQty} Discount ${parseFloat(discount)}%`,
            );

            tags.push({
              id: `${promo.promotion_id}_${promo.quantity_offer_id}`,
              label: formattedPromoName,
              type: 4,
              offerType: "1",
              offerDiscount: promo.discount,
              icon: <Tag size={14} />,
            });
          } else {
            // Find the free quantity from children
            let freeQty = 0;
            if (Array.isArray(promo.children)) {
              const focChild = promo.children.find(
                (child) =>
                  child.is_foc === 1 &&
                  child.quantity_offer_id === promo.quantity_offer_id,
              );
              if (focChild) {
                freeQty = Number(focChild.quantity);
              }
            }
            if (freeQty > 0) {
              tags.push({
                id: `${promo.promotion_id}_${promo.quantity_offer_id}`,
                label: `${promo.promo_name}`,
                type: 4,
                offerType: "0",
                icon: <Tag size={14} />,
              });
            }
          }
          seen.add(tagId);
        }
      }

      // PWP — prefer pwp_promotion_id: it's set independently of
      // promotion_id now, so it works both for the main item (which may
      // carry its own Discount/Quantity Offer promo_id at the same time)
      // and for the PWP addon child row (whose promotion_id is now its own
      // real promo FK, with pwp_promotion_id as the pwp_info sub id).
      // Falls back to promotion_id for rows inserted before that column
      // existed (legacy data, promotion_type is still 5 there).
      const pwpId = resolvePwpCompositeId(promo);
      if (pwpId) {
        const tagId = `5_${pwpId}`;
        if (!seen.has(tagId)) {
          tags.push({
            id: pwpId,
            label: "PWP",
            type: 5,
            icon: <Tag size={14} />,
          });
          seen.add(tagId);
        }
      }

      // Display Discount
      if (type === 6 && promo.promotion_id) {
        const tagId = `6_${promo.promotion_id}`;
        if (!seen.has(tagId)) {
          tags.push({
            id: promo.promotion_id,
            label: "Display Discount",
            type: 6,
            icon: <Tag size={14} />,
          });
          seen.add(tagId);
        }
      }
    });
    return tags;
  }

  const handlePromotionTagClick = (
    id,
    tags,
    selectedPromotionIds,
    setSelectedPromotionIds,
  ) => {
    const clickedTag = tags.find((tag) => tag.id === id);
    if (!clickedTag) return;

    if (selectedPromotionIds.includes(id)) {
      // 取消选择
      setSelectedPromotionIds(selectedPromotionIds.filter((pid) => pid !== id));
    } else {
      // 选择
      setSelectedPromotionIds([...selectedPromotionIds, id]);
    }
  };

  function mergeFreeGiftBranches(branches) {
    const merged = {};
    branches.forEach((branch) => {
      // console.log("Merging branch:", branch);
      const key = `${branch.branch_code || "HQ"}-${branch.itemName}`;

      if (branch.promoTag === "Free Gift") {
        // Free Gift 类型：合并同一分支的数量
        if (!merged[key]) {
          merged[key] = { ...branch, quantity: Number(branch.quantity) };
        } else {
          merged[key].quantity += Number(branch.quantity);
        }
      } else {
        // 其他类型：保持独立，使用唯一 key 避免合并
        const uniqueKey = `${key}-${branch.itemId}-${branch.promoTag}`;
        merged[uniqueKey] = { ...branch, quantity: Number(branch.quantity) };
      }
    });
    return Object.values(merged);
  }

  function mergeFreeGiftCards(children) {
    const merged = {};
    children.forEach((child) => {
      if (child.promotion_type === "2") {
        // 只合并 Free Gift 类型
        // 累加所有 branch 的数量
        let totalQty = 0;
        if (Array.isArray(child.cargo_dist)) {
          totalQty = child.cargo_dist.reduce(
            (sum, branch) => sum + Number(branch.quantity || 0),
            0,
          );
        }
        const key = child.item_name;
        if (!merged[key]) {
          merged[key] = { ...child, quantity: totalQty };
        } else {
          merged[key].quantity += totalQty;
        }
      }
    });
    return Object.values(merged);
  }

  function mergeChildrenByItemCode(children) {
    const merged = {};
    children.forEach((child) => {
      const totalQty = Array.isArray(child.cargo_dist)
        ? child.cargo_dist.reduce((sum, b) => sum + Number(b.quantity || 0), 0)
        : 0;
      const key = child.item_code || child.item_name;
      if (!merged[key]) {
        merged[key] = { ...child, quantity: totalQty };
      } else {
        merged[key].quantity += totalQty;
      }
    });
    return Object.values(merged);
  }

  // CartItem component to handle its own state properly
  const CartItem = ({
    item,
    formatCurrency,
    activeBranchItemId,
    setActiveBranchItemId,
    activePromoItemId,
    setActivePromoItemId,
  }) => {
    const showCurrPromoMenu = activePromoItemId === item.id;
    const showCartBranch = activeBranchItemId === item.id;

    // 1. Show the promotion tags for each cart item
    const appliedPromoIds = (item.promotion_id || "")
      .split(",")
      .map((id) => id.trim());
    // const allTags = getPromotionTags(item.promo_detail || []);
    const allTags = getPromotionTags([item, ...(item.children || [])]);

    const tags = allTags.filter((tag) => {
      if (tag.type === 4) {
        // Quantity offer: match both promotion_id and quantity_offer_id
        return (
          item.promotion_id &&
          item.quantity_offer_id &&
          tag.id === `${item.promotion_id}_${item.quantity_offer_id}`
        );
      } else if (tag.type === 2) {
        // Free Gift: match free_gift_id
        return item.free_gift_id && tag.id === item.free_gift_id;
      } else if (tag.type === 5) {
        // PWP: match by pwp_promotion_id — it's independent of promotion_id
        // now, so the item's own Discount/Quantity Offer can be selected at
        // the same time. Falls back to promotion_id for legacy rows.
        // PWP: allTags is already scoped to just this item + its children
        // (see getPromotionTags call above), so any type-5 tag in it was
        // necessarily built from one of this item's own addon rows.
        return true;
      } else {
        // Other promo: match by promotion_id only
        return item.promotion_id && tag.id === item.promotion_id;
      }
    });

    // 2. Allow user to view and select which promotion
    const [selectedPromotionId, setSelectedPromotionId] = useState(
      tags.length > 0 ? tags[0].id : "",
    );
    const defaultSelected = tags
      .filter((tag) => tag.type === 2)
      .map((tag) => tag.id);
    const [selectedPromotionIds, setSelectedPromotionIds] =
      useState(defaultSelected);
    const [showPromotionDropdown, setShowPromotionDropdown] = useState(false);

    const handlePromotionTagClick = (id) => {
      setSelectedPromotionId(id);
      setShowPromotionDropdown(false);
    };

    // 3. Filter and display promotion_id relevant to the cart item
    // (PWP children carry the link in pwp_promotion_id instead — new rows
    // split it as promotion_id + pwp_promotion_id sub id)
    const filteredChildren = (item.children || []).filter((child) => {
      if (child.promotion_id === selectedPromotionId) return true;
      const childPwpId = resolvePwpCompositeId(child);
      return childPwpId && childPwpId === selectedPromotionId;
    });

    // 4. Filter and display cargo_dist relevant to the cart item
    const filteredBranches = [];
    filteredChildren.forEach((child) => {
      if (child.cargo_dist && Array.isArray(child.cargo_dist)) {
        child.cargo_dist.forEach((branch) => {
          filteredBranches.push({
            ...branch,
            childName: child.item_name,
            childPrice: child.price,
            childId: child.id,
          });
        });
      }
    });
    const mergedChildren = mergeFreeGiftCards(filteredChildren);

    // Collect all branches from main item and children, with promotion info
    const allBranches = [];

    // Collect promotional branches from children
    (item.children || []).forEach((child) => {
      // const tag = getPromotionTags(item.promo_detail || []).find(
      //   (t) => t.id === child.promotion_id
      // );
      const childPwpId = resolvePwpCompositeId(child);
      const tag = getPromotionTags([item, ...(item.children || [])]).find(
        (t) =>
          t.id === child.promotion_id ||
          (child.pwp_promotion_id && t.id === childPwpId),
      );

      (child.cargo_dist || []).forEach((branch) => {
        allBranches.push({
          branch_code: branch.branch_code,
          quantity: branch.quantity,
          itemName: child.item_name,
          itemPrice: child.price,
          promoType: tag ? tag.label : "Promotion",
          promoIcon: tag ? tag.icon : null,
        });
      });
    });

    // Optionally, only add main item branches that are not covered by promotions
    (item.cargo_dist || []).forEach((branch) => {
      const isPromoted = allBranches.some(
        (b) => b.branch_code === branch.branch_code,
      );
      if (!isPromoted) {
        allBranches.push({
          branch_code: branch.branch_code,
          quantity: branch.quantity,
          itemName: item.item_name,
          itemPrice: item.price,
          promoType: "No Promotion",
          promoIcon: null,
        });
      }
    });

    // Create displayBranches by merging free gift branches (same as MyShoppingCart)
    const displayBranches = mergeFreeGiftBranches(allBranches);
    const uniqueBranchCount = new Set(
      displayBranches.map((b) => b.branch_code || "HQ"),
    ).size;

    return (
      <div
        className={`cartitem-container_v2 ${
          item.not_available ? "out-of-stock-item_v2" : ""
        }`}
        id={`cartitem-${item.item_id}-${item.id}`}
      >
        <div className="badge-container_v2">
          {item.is_package === 1 && (
            <div className="package-badge_v2">
              PACKAGE : {item.package_name}
            </div>
          )}
          {item.quotation_id && item.quotation_id !== "" && (
            <div className="quotation-badge_v2">
              QUOTATION : {item.quotation_id}
            </div>
          )}
          {item.is_support_item && (
            <div className="quotation-badge_v2">SPONSOR</div>
          )}
        </div>
        {/* Main item information */}
        <div className="cartitem-inner_v2">
          <div className="cart-image-container_v2">
            {item.not_available && (
              <div className="out-of-stock-overlay_v2">Not available</div>
            )}
            <FallbackImg
              src={item.img.thumb}
              alt={item.item_name}
              className="cartitem-image_v2"
            />
          </div>

          <div className="cartitem-details_v2">
            <div className="cartitem-top-row_v2">
              <div style={{ width: "80%" }}>
                <div className="cartitem-code_v2">{item.item_code}</div>
                <div className="cartitem-name_v2">{item.item_name}</div>
              </div>
            </div>

            <div className="cartitem-bot-row_v2">
              <div className="cartitem-price_v2">
                <div className="cartitem-price-title_v2">Unit Price</div>
                {/* {(() => {
                  const selectedTag = tags.find(
                    (tag) => tag.id === selectedPromotionId,
                  );
                  const originalPrice =
                    Number(item.price) + Number(item.discount || 0);

                  // FOCPrice calculation
                  const quantity = item.cargo_dist
                    ? item.cargo_dist.reduce(
                        (sum, branch) => sum + Number(branch.quantity || 0),
                        0,
                      )
                    : 0;

                  const foc = (item.children || [])
                    .filter((child) => String(child.promotion_type) === "4")
                    .reduce((sum, child) => {
                      if (Array.isArray(child.cargo_dist)) {
                        return (
                          sum +
                          child.cargo_dist.reduce(
                            (s, b) => s + Number(b.quantity || 0),
                            0,
                          )
                        );
                      }
                      return sum;
                    }, 0);

                  const FOCPrice =
                    (quantity * originalPrice) / (quantity + foc);

                  // Show discounted price only for Item Discount (type === 3)
                  if (selectedTag && selectedTag.type === 3) {
                    return (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <span className="normalprice_v2">
                          RM{" "}
                          {item.brand_price
                            ? formatCurrency(item.brand_price)
                            : "0.00"}
                        </span>
                        <span className="deductedprice_v2">
                          RM{" "}
                          {originalPrice
                            ? formatCurrency(originalPrice)
                            : "0.00"}
                        </span>
                      </div>
                    );
                  }

                  // Show discounted price only for Buy X Discount Y (type === 4)
                  else if (
                    selectedTag &&
                    selectedTag.type === 4 &&
                    selectedTag.offerType === "1"
                  ) {
                    return (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <span className="normalprice_v2">
                          RM {item.price ? formatCurrency(item.price) : "0.00"}
                        </span>
                        <span className="deductedprice_v2">
                          RM{" "}
                          {originalPrice
                            ? formatCurrency(originalPrice)
                            : "0.00"}
                        </span>
                      </div>
                    );
                  }

                  // Show discounted price only for Buy X Free Y (type === 4)
                  else if (selectedTag && selectedTag.type === 4) {
                    return (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <span className="normalprice_v2">
                          RM {FOCPrice ? formatCurrency(FOCPrice) : "0.00"}
                        </span>
                        <span className="deductedprice_v2">
                          RM{" "}
                          {originalPrice
                            ? formatCurrency(originalPrice)
                            : "0.00"}
                        </span>
                      </div>
                    );
                  }

                  // Otherwise, show only the current price
                  return (
                    <span className="normalprice_v2">
                      RM {item.price ? formatCurrency(item.price) : "0.00"}
                    </span>
                  );
                })()} */}
                {(() => {
                  const selectedTag = tags.find(
                    (tag) => tag.id === selectedPromotionId,
                  );

                  return selectedTag &&
                    (selectedTag.type === 3 ||
                      (selectedTag.type === 4 &&
                        selectedTag.offerType === "1")) ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <span className="normalprice_v2">
                        RM{" "}
                        {item.final_price
                          ? formatCurrency(item.final_price)
                          : "0.00"}
                      </span>
                      <span className="deductedprice_v2">
                        RM{" "}
                        {item.original_price
                          ? formatCurrency(item.original_price)
                          : "0.00"}
                      </span>
                    </div>
                  ) : (
                    <span className="normalprice_v2">
                      RM {item.price ? formatCurrency(item.price) : "0.00"}
                    </span>
                  );
                })()}
              </div>

              {!item.not_available && (
                <>
                  <div className="cartitem-qty_v2">
                    <div className="cartitem-qty-title_v2">Quantity</div>
                    <div className="cartitem-qty-value-container_v2">
                      <div className="cartitem-qty-value_v2">
                        {item.cargo_dist
                          ? item.cargo_dist.reduce(
                              (sum, branch) =>
                                sum + Number(branch.quantity || 0),
                              0,
                            )
                          : 0}
                      </div>
                      {(() => {
                        const focQty = (item.children || [])
                          .filter(
                            (child) => String(child.promotion_type) === "4",
                          )
                          .reduce((sum, child) => {
                            if (Array.isArray(child.cargo_dist)) {
                              return (
                                sum +
                                child.cargo_dist.reduce(
                                  (s, b) => s + Number(b.quantity || 0),
                                  0,
                                )
                              );
                            }
                            return sum;
                          }, 0);

                        return focQty > 0 ? (
                          <div className="cartitem-qty-foc_v2">
                            + {focQty} free
                          </div>
                        ) : null;
                      })()}
                    </div>
                  </div>

                  <div className="cartitem-total_v2">
                    <div className="cartitem-total-title_v2">Subtotal</div>
                    <div className="cartitem-RM-container_v2">
                      <div className="cartitem-RM_v2">RM</div>
                      {formatCurrency(
                        (item.price ? Number(item.price) : 0) *
                          (item.cargo_dist
                            ? item.cargo_dist.reduce(
                                (sum, branch) =>
                                  sum + Number(branch.quantity || 0),
                                0,
                              )
                            : 0),
                      )}
                    </div>
                    {(() => {
                      const focQty = (item.children || [])
                        .filter((child) => String(child.promotion_type) === "4")
                        .reduce((sum, child) => {
                          if (Array.isArray(child.cargo_dist)) {
                            return (
                              sum +
                              child.cargo_dist.reduce(
                                (s, b) => s + Number(b.quantity || 0),
                                0,
                              )
                            );
                          }
                          return sum;
                        }, 0);

                      return focQty > 0 ? (
                        <div className="cartitem-RM-foc_v2">
                          Save RM{" "}
                          {item.price
                            ? formatCurrency(item.price * focQty)
                            : "0.00"}{" "}
                          on {focQty} free {focQty > 1 ? "units" : "unit"}
                        </div>
                      ) : null;
                    })()}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

        <div className="branch-toggle-container_v2">
          <div
            className="branch-toggle_v2"
            onClick={(e) => {
              e.stopPropagation();
              const next = showCartBranch ? null : item.id;
              setActiveBranchItemId(next);
              if (next !== null) setActivePromoItemId(null);
            }}
          >
            <div className="branch-toggle-left_v2">
              <Package size={16} color={"#1e5bc6"} />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "2px",
                  fontSize: "14px",
                }}
              >
                Stock Allocation
                <div className="branch-toggle-count_v2">
                  {uniqueBranchCount || 0}{" "}
                  {uniqueBranchCount === 1 ? "branch" : "branches"} allocated
                </div>
              </div>
            </div>
            <ChevronDown
              size={16}
              className={showCartBranch ? "rotate_v2" : ""}
            />
          </div>

          {tags.length > 0 && (
            <div
              className="currpromo-dropdown_v2"
              onClick={(e) => {
                e.stopPropagation();
                const next = showCurrPromoMenu ? null : item.id;
                setActivePromoItemId(next);
                if (next !== null) setActiveBranchItemId(null);
              }}
            >
              <div className="currpromo-dropdown-left_v2">
                <Tag size={16} color={"#00a63e"} />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                    fontSize: "14px",
                  }}
                >
                  Applied Promotions
                  <div className="currpromo-dropdown-count_v2">
                    {tags.length || 0}{" "}
                    {tags.length === 1 ? "promotion" : "promotions"} applied
                  </div>
                </div>
              </div>
              <ChevronDown
                size={16}
                className={showCurrPromoMenu ? "rotate_v2" : ""}
              />
            </div>
          )}
        </div>

        {/* CSS in ShoppingCartBranch.css */}
        {showCartBranch && (
          <BranchDistributionModal
            branches={item.branchData || []}
            promotionTypes={item.promotionTypes || []}
            offerTypes={item.offerTypes || []}
          />
        )}

        {/* Show All Promotion */}
        {showCurrPromoMenu && tags.length > 0 && (
          <div className="currpromo-menu_v2">
            <div className="currpromo-title_v2">Applied Promotions</div>
            {tags.map((tag) => {
              // For each tag, find the children and render the promo card.
              // PWP children carry the link in pwp_promotion_id (their own
              // promotion_id is "0"), so match on that for PWP tags.
              const promoChildren = (item.children || []).filter((child) =>
                tag.type === 5
                  ? resolvePwpCompositeId(child) === tag.id
                  : child.promotion_id === tag.id,
              );

              const mergedPromoChildren =
                mergeChildrenByItemCode(promoChildren);

              // Item Discount (type 3)
              if (tag.type === 3) {
                const originalPrice =
                  Number(item.price) + Number(item.discount || 0);
                return (
                  <div
                    className="currpromo-branch_v2"
                    key={item.item_id + "-" + tag.id}
                  >
                    <div className="currpromo-left_v2">
                      <FallbackImg src={item.img?.thumb} alt={item.item_name} />
                    </div>
                    <div className="currpromo-center_v2">
                      <div className="promoitem-name_v2">{item.item_code}</div>
                      <div className="promoitem-qty_v2">
                        Quantity :{" "}
                        {item.cargo_dist.reduce(
                          (sum, b) => sum + Number(b.quantity || 0),
                          0,
                        )}
                      </div>
                      <div className="promoitem-price_v2">
                        <span>
                          RM{" "}
                          {item.brand_price
                            ? formatCurrency(item.brand_price)
                            : "0.00"}
                        </span>
                        <span
                          style={{
                            textDecoration: "line-through",
                            color: "#a1a1a1",
                            marginLeft: 8,
                            fontSize: "12px",
                          }}
                        >
                          RM{" "}
                          {originalPrice
                            ? formatCurrency(originalPrice)
                            : "0.00"}
                        </span>
                      </div>
                    </div>
                    <div className="currpromo-right_v2">
                      <div className="promoitem-tag_v2 orange">
                        {tag.icon}
                        {tag.label}
                      </div>
                    </div>
                  </div>
                );
              }

              // Free Gift (type 2)
              if (tag.type === 2 && promoChildren.length > 0) {
                const totalQty = promoChildren.reduce((sum, child) => {
                  if (Array.isArray(child.cargo_dist)) {
                    return (
                      sum +
                      child.cargo_dist.reduce(
                        (s, b) => s + Number(b.quantity || 0),
                        0,
                      )
                    );
                  }
                  return sum;
                }, 0);
                const child = promoChildren[0];
                return (
                  <div
                    className="currpromo-branch_v2"
                    key={child.item_name + "-" + tag.id}
                  >
                    <div className="currpromo-left_v2">
                      <FallbackImg
                        src={child.img?.thumb}
                        alt={child.item_name}
                      />
                    </div>
                    <div className="currpromo-center_v2">
                      <div className="promoitem-name_v2">{child.item_code}</div>
                      <div className="promoitem-qty_v2">
                        Quantity : {totalQty}
                      </div>
                      <div className="promoitem-price_v2">
                        <span>RM 0.00</span>
                      </div>
                    </div>
                    <div className="currpromo-right_v2">
                      <div className="promoitem-tag_v2 green">
                        {tag.icon}
                        {tag.label}
                      </div>
                    </div>
                  </div>
                );
              }

              // Quantity Offer - Buy X Discount Y (type 4, offerType 1)
              if (tag.type === 4 && tag.offerType === "1") {
                const originalPrice =
                  Number(item.price) + Number(item.discount || 0);
                return (
                  <div
                    className="currpromo-branch_v2"
                    key={item.item_id + "-" + tag.id}
                  >
                    <div className="currpromo-left_v2">
                      <FallbackImg src={item.img?.thumb} alt={item.item_name} />
                    </div>
                    <div className="currpromo-center_v2">
                      <div className="promoitem-name_v2">{item.item_code}</div>
                      <div className="promoitem-qty_v2">
                        Quantity :{" "}
                        {item.cargo_dist.reduce(
                          (sum, b) => sum + Number(b.quantity || 0),
                          0,
                        )}
                      </div>
                      <div className="promoitem-price_v2">
                        <span>
                          RM {item.price ? formatCurrency(item.price) : "0.00"}
                        </span>
                        <span
                          style={{
                            textDecoration: "line-through",
                            color: "#a1a1a1",
                            marginLeft: 8,
                            fontSize: "12px",
                          }}
                        >
                          RM{" "}
                          {originalPrice
                            ? formatCurrency(originalPrice)
                            : "0.00"}
                        </span>
                      </div>
                    </div>
                    <div className="currpromo-right_v2">
                      <div className="promoitem-tag_v2 purple">
                        {tag.icon}
                        {tag.label}
                      </div>
                    </div>
                  </div>
                );
              }

              // Quantity Offer - Buy X Free Y (type 4, offerType 0)
              if (tag.type === 4) {
                // Sum all cargo_dist quantities for children with promotion_type === 4
                const totalFocQty = (item.children || [])
                  .filter((child) => String(child.promotion_type) === "4")
                  .reduce((sum, child) => {
                    if (Array.isArray(child.cargo_dist)) {
                      return (
                        sum +
                        child.cargo_dist.reduce(
                          (s, b) => s + Number(b.quantity || 0),
                          0,
                        )
                      );
                    }
                    return sum;
                  }, 0);
                return (
                  <div
                    className="currpromo-branch_v2"
                    key={item.item_id + "-" + tag.id}
                  >
                    <div className="currpromo-left_v2">
                      <FallbackImg src={item.img?.thumb} alt={item.item_name} />
                    </div>
                    <div className="currpromo-center_v2">
                      <div className="promoitem-name_v2">{item.item_code}</div>
                      <div className="promoitem-qty_v2">
                        Quantity : {totalFocQty}
                      </div>
                      <div className="promoitem-price_v2">
                        <span>RM 0.00</span>
                      </div>
                    </div>
                    <div className="currpromo-right_v2">
                      <div className="promoitem-tag_v2 purple">
                        {tag.icon}
                        {tag.label}
                      </div>
                    </div>
                  </div>
                );
              }

              // Other promo types (e.g., PWP, Display Discount, etc.)
              return mergedPromoChildren.map((child) => {
                const totalQty = child.quantity; // already summed by the merge step

                return (
                  <div
                    className="currpromo-branch_v2"
                    key={child.item_code + "-" + tag.id}
                  >
                    <div className="currpromo-left_v2">
                      <FallbackImg
                        src={child.img?.thumb}
                        alt={child.item_name}
                      />
                    </div>
                    <div className="currpromo-center_v2">
                      <div className="promoitem-name_v2">{child.item_code}</div>
                      <div className="promoitem-qty_v2">
                        Quantity : {totalQty}
                      </div>
                      <div className="promoitem-price_v2">
                        {child.promotion_type === "2" ||
                        child.promotion_type === "4" ? (
                          <span>RM 0.00</span>
                        ) : (
                          <>
                            <span>
                              RM{" "}
                              {child.price
                                ? formatCurrency(child.price)
                                : "0.00"}
                            </span>
                            <span
                              style={{
                                textDecoration: "line-through",
                                color: "#a1a1a1",
                                marginLeft: 8,
                                fontSize: "12px",
                              }}
                            >
                              RM{" "}
                              {formatCurrency(
                                Number(child.price) +
                                  Number(child.discount || 0),
                              )}
                            </span>
                          </>
                        )}
                      </div>
                    </div>
                    <div className="currpromo-right_v2">
                      <div className="promoitem-tag_v2 orange">
                        {tag.icon}
                        {tag.label}
                      </div>
                    </div>
                  </div>
                );
              });
            })}
          </div>
        )}
      </div>
    );
  };

  // Sort items so out of stock appears at the bottom
  const sortCartItems = (items) => {
    if (!items) return [];

    // Create a new array with in-stock items first, then out-of-stock items
    const sortedItems = [];
    const outOfStockItems = [];

    items.forEach((item) => {
      if (item.not_available) {
        outOfStockItems.push(item);
      } else {
        sortedItems.push(item);
      }
    });

    // Combine the arrays with in-stock items first
    return [...sortedItems, ...outOfStockItems];
  };

  const branchOptionsRaw = (
    checkoutData && checkoutData.items_by_branch
      ? checkoutData.items_by_branch
      : []
  ).map((branch) => {
    // Calculate totals for this branch across all cart items
    let totalQuantity = 0;
    // let totalAmount = 0;

    // const quesmarkRef = useRef(null);
    // const [showTooltip, setShowTooltip] = useState(false);

    const totalCBM = branch.items.reduce(
      (sum, item) => sum + (Number(item.cbm) || 0),
      0,
    );

    // Calculate totalQuantity as before if you need it
    if (cartItems && Array.isArray(cartItems)) {
      cartItems.forEach((item) => {
        const branchData = (item.cargo_dist || []).find(
          (b) => b.branch_code === branch.branch_code,
        );
        if (branchData) {
          totalQuantity += Number(branchData.quantity) || 0;
        }
      });
    }

    const shippingDetail = Array.isArray(checkoutData.branch_shipping_detail)
      ? checkoutData.branch_shipping_detail.find(
          (d) => d.branch_code === branch.branch_code,
        )
      : null;

    const totalAmount = shippingDetail?.subtotal ?? 0;

    const isRed =
      shippingDetail &&
      (!shippingDetail.is_free_shipping || shippingDetail.is_east_malaysia);

    const shippingFee =
      shippingDetail?.shipping_fee != null
        ? Number(shippingDetail.shipping_fee)
        : 0;

    return {
      value: branch.branch_code,
      label: (
        <BranchDropdownOption
          branch={branch}
          shippingDetail={shippingDetail}
          totalCBM={totalCBM}
          totalAmount={totalAmount}
          isRed={isRed}
          shippingFee={shippingFee}
        />
      ),
      isRed,
    };
  });

  // Add header row as the first option (disabled)
  const branchOptions = [
    {
      value: "",
      label: (
        <div className="branch-custom-dropdown-header_v2">
          <span style={{ width: "20%", marginLeft: "20px" }}>Branch Name</span>
          {/* <span style={{ width: "10%" }}>Quantity</span> */}
          <span style={{ width: "15%" }}>CBM</span>
          <span style={{ width: "20%", textAlign: "right" }}>
            Shipping Charges
          </span>
          <span style={{ width: "20%", textAlign: "right" }}>Amount</span>
        </div>
      ),
      isDisabled: true,
    },
    ...branchOptionsRaw,
  ];

  const handleBranchSelect = (option) => {
    setSelectedBranch(option.value);
    const branch = checkoutData.items_by_branch.find(
      (b) => b.branch_code === option.value,
    );
    setSelectedBranchData(branch || null);
    setShowCheckoutBranch(!!option.value);
    setShowBranchDropdown(false);
  };

  const handleBranchSpecialDateChange = (branchCode, date) => {
    setBranchSpecialDates((prev) => ({ ...prev, [branchCode]: date }));
  };

  const handleBranchSpecialToggle = (branchCode, enabled) => {
    setBranchSpecialEnabled((prev) => ({ ...prev, [branchCode]: enabled }));
    if (!enabled) {
      setBranchSpecialDates((prev) => ({ ...prev, [branchCode]: null }));
    }
  };

  const BranchDistributionModal = ({
    branches,
    promotionTypes = [],
    offerTypes = [],
  }) => {
    const isFOC = promotionTypes.includes(4) && offerTypes.includes("0");
    const isPWP = promotionTypes.includes(5);
    const isDisplayDiscount = promotionTypes.includes(6);
    const isFreeGift = promotionTypes.includes(2);
    const renderedBranchNames = new Set();

    // Holds { branch_code, items: [{code, qty}] } for the branch whose
    // "View More" was clicked, or null when the modal is closed.
    const [pwpDetailBranch, setPwpDetailBranch] = useState(null);

    const totalMainQty = branches
      ? branches
          .filter(
            (b) =>
              !b.isChild &&
              ((b.promoType &&
                b.promoType.startsWith("Buy ") &&
                b.promoType.includes(" Free ")) ||
                (b.promoType.startsWith("Buy ") &&
                  b.promoType.includes(" Discount ")) ||
                b.promoType === "PWP" ||
                b.promoType === "Display Discount" ||
                b.promoType === "Item Discount" ||
                b.promoType === "No Promotion"),
          )
          .reduce((sum, b) => sum + Number(b.quantity || 0), 0)
      : 0;

    const totalFOCQty = branches
      ? branches
          .filter(
            (b) =>
              b.isChild &&
              b.promoType &&
              b.promoType.startsWith("Buy ") &&
              b.promoType.includes(" Free "),
          )
          .reduce((sum, b) => sum + Number(b.quantity || 0), 0)
      : 0;

    const totalPWPQty = branches
      ? branches
          .filter((b) => b.isChild && b.promoType === "PWP")
          .reduce((sum, b) => sum + Number(b.quantity || 0), 0)
      : 0;

    const totalDisplayDiscountQty = branches
      ? branches
          .filter((b) => b.isChild && b.promoType === "Display Discount")
          .reduce((sum, b) => sum + Number(b.quantity || 0), 0)
      : 0;

    const totalFreeGiftQty = branches
      ? branches
          .filter((b) => b.promoType === "Free Gift")
          .reduce((sum, b) => sum + Number(b.quantity || 0), 0)
      : 0;

    const totalPrice = branches
      ? branches.reduce(
          (sum, b) => sum + Number(b.itemPrice || 0) * Number(b.quantity || 0),
          0,
        )
      : 0;

    const uniqueBranchCodes = Array.from(
      new Set(branches.map((b) => b.branch_code)),
    );

    return (
      <>
        <div className="shoppingcartbranch_v2">
          <div className="scb-title_v2">
            <div>Branch Distribution</div>
          </div>

          <div className="shoppingcartbranch-content_v2">
            <div className="scb-branch-header_v2">
              <div className="scb-subtitle-col1_v2">Branch</div>
              <div className="scb-subtitle-remaincol_v2">Quantity</div>
              {isFOC && <div className="scb-subtitle-remaincol_v2">F.O.C</div>}
              {isPWP && <div className="scb-subtitle-remaincol_v2">PWP</div>}
              {isDisplayDiscount && (
                <div className="scb-subtitle-remaincol_v2">Discount</div>
              )}
            </div>

            {branches && branches.length > 0 ? (
              (() => {
                const anyBranchHasMultiplePwpCodes = branches.some((b) => {
                  const grp = branches.filter(
                    (x) => x.branch_code === b.branch_code,
                  );
                  const codes = [
                    ...new Set(
                      grp
                        .filter((x) => x.isChild && x.promoType === "PWP")
                        .map((x) => x.itemCode),
                    ),
                  ];
                  return codes.length > 1;
                });
                return branches.map((branch, idx) => {
                  // Only render branch name once per branch_code
                  if (renderedBranchNames.has(branch.branch_code)) return null;
                  renderedBranchNames.add(branch.branch_code);

                  // Find all branches for this branch_code
                  const branchGroup = branches.filter(
                    (b) => b.branch_code === branch.branch_code,
                  );

                  // Sum quantities for each type
                  const mainQty = branchGroup
                    .filter(
                      (b) =>
                        !b.isChild &&
                        ((b.promoType &&
                          b.promoType.startsWith("Buy ") &&
                          b.promoType.includes(" Free ")) ||
                          (b.promoType.startsWith("Buy ") &&
                            b.promoType.includes(" Discount ")) ||
                          b.promoType === "PWP" ||
                          b.promoType === "Display Discount" ||
                          b.promoType === "Item Discount" ||
                          b.promoType === "No Promotion"),
                    )
                    .reduce((sum, b) => sum + Number(b.quantity || 0), 0);

                  const focQty = branchGroup
                    .filter(
                      (b) =>
                        b.isChild &&
                        b.promoType &&
                        b.promoType.startsWith("Buy ") &&
                        b.promoType.includes(" Free "),
                    )
                    .reduce((sum, b) => sum + Number(b.quantity || 0), 0);

                  const pwpQty = branchGroup
                    .filter((b) => b.isChild && b.promoType === "PWP")
                    .reduce((sum, b) => sum + Number(b.quantity || 0), 0);

                  const discountQty = branchGroup
                    .filter(
                      (b) => b.isChild && b.promoType === "Display Discount",
                    )
                    .reduce((sum, b) => sum + Number(b.quantity || 0), 0);

                  const freeGiftQty = branchGroup
                    .filter((b) => b.promoType === "Free Gift")
                    .reduce((sum, b) => sum + Number(b.quantity || 0), 0);

                  // Distinct PWP item codes for THIS branch only, in first-seen order
                  const branchPwpCodes = [];
                  branchGroup
                    .filter((b) => b.isChild && b.promoType === "PWP")
                    .forEach((b) => {
                      if (!branchPwpCodes.includes(b.itemCode)) {
                        branchPwpCodes.push(b.itemCode);
                      }
                    });

                  return (
                    <div key={idx} className="shoppingcartbranch-main_v2">
                      <div className="scb-branchname-container_v2">
                        <div className="scb-branchname_v2">
                          {branch.branch_code || "HQ"}
                        </div>

                        {/* Main quantity */}
                        <div className="scb-productqty-container_v2">
                          <div className="scb-productqty-value_v2">
                            {mainQty}
                          </div>
                        </div>

                        {/* FOC quantity */}
                        {isFOC && (
                          <div className="scb-productqty-container_v2">
                            <div className="scb-productqty-value_v2">
                              {focQty}
                            </div>
                          </div>
                        )}

                        {/* PWP quantity */}
                        {isPWP && (
                          <div
                            className="scb-productqty-container_v2"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            {anyBranchHasMultiplePwpCodes && (
                              <button
                                type="button"
                                className="scb-viewmore-btn_v2"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setPwpDetailBranch({
                                    branch_code: branch.branch_code || "HQ",
                                    items: branchPwpCodes.map((code) => ({
                                      code,
                                      qty: branchGroup
                                        .filter(
                                          (b) =>
                                            b.isChild &&
                                            b.promoType === "PWP" &&
                                            b.itemCode === code,
                                        )
                                        .reduce(
                                          (sum, b) =>
                                            sum + Number(b.quantity || 0),
                                          0,
                                        ),
                                    })),
                                  });
                                }}
                              >
                                View More
                              </button>
                            )}
                            <div className="scb-productqty-value_v2">
                              {pwpQty}
                            </div>
                          </div>
                        )}

                        {/* Display Discount quantity */}
                        {isDisplayDiscount && (
                          <div className="scb-productqty-container_v2">
                            <div className="scb-productqty-value_v2">
                              {discountQty}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                });
              })()
            ) : (
              <div>No branch info available.</div>
            )}
          </div>
        </div>

        {pwpDetailBranch && (
          <MultiPurpose
            title={`PWP Branch Distribution - ${pwpDetailBranch.branch_code}`}
            hideNo={true}
            yesText="Close"
            onYes={() => setPwpDetailBranch(null)}
            onClose={() => setPwpDetailBranch(null)}
          >
            <div className="shoppingcartbranch-content_v2">
              <div
                className="scb-branch-header_v2"
                style={{ textAlign: "left" }}
              >
                <div className="scb-subtitle-col1_v2">Branch</div>
                {pwpDetailBranch.items.map((it) => (
                  <div key={it.code} className="scb-subtitle-remaincol_v2">
                    {it.code}
                  </div>
                ))}
              </div>

              <div className="shoppingcartbranch-main_v2">
                <div className="scb-branchname-container_v2">
                  <div className="scb-branchname_v2">
                    {pwpDetailBranch.branch_code}
                  </div>
                  {pwpDetailBranch.items.map((it) => (
                    <div key={it.code} className="scb-productqty-container_v2">
                      <div className="scb-productqty-value_v2">{it.qty}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </MultiPurpose>
        )}
      </>
    );
  };

  // Handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
    setCartData(null); // Clear cart data before loading new page
    fetchCartData(page, pricingType, "", selectedItems, selectedCsIds);
  };

  return (
    <>
      {loading ? (
        <div className="loading-container_v2">Loading checkout data...</div>
      ) : error && !checkoutData ? (
        <div className="error-container_v2">
          {error}
          <div>
            <Link to="/myshoppingcart">Return to Shopping Cart</Link>
          </div>
        </div>
      ) : (
        <div className="checkout_v2">
          <Breadcrums />
          <div className="checkout-content_v2">
            <div className="checkout-title-container_v2">
              <Link to="/myshoppingcart" className="checkout-title_v2">
                <ArrowLeft size={24} />
                <span>CHECKOUT</span>
              </Link>
            </div>

            <div className="checkout-container_v2">
              <div className="checkout-left_v2">
                {isStaffPurchase && (
                  <div className="staff-info_v2">
                    <div className="staff-container_v2">
                      <div className="staff-subtitle_v2">Order By</div>
                      <div className="staff-colon_v2">:</div>
                      <div className="staff-value-container_v2">
                        <strong>{orderBy || "-"}</strong>
                      </div>
                    </div>
                    <label className="staff-container_v2">
                      <div className="staff-subtitle_v2">Staff Name</div>
                      <div className="staff-colon_v2">:</div>
                      <div className="staff-value-container_v2">
                        <CustomDropdown
                          options={[
                            ...staffList.map((staff) => ({
                              value: staff.id,
                              label: staff.name,
                            })),
                          ]}
                          value={selectedStaffId}
                          onChange={(val, opt) => {
                            setSelectedStaffId(val);
                            setSelectedStaffName(opt ? opt.label : "");
                          }}
                          placeholder="Select staff"
                          className="checkout-dropdown_v2"
                        />
                      </div>
                    </label>
                  </div>
                )}

                {/* Branch dropdown */}
                <div className="branch-custom-dropdown_v2">
                  <div
                    className={`branch-custom-dropdown-selected_v2${
                      hasShippingFeeOrEastMalaysia
                        ? " branch-dropdown-red_v2"
                        : ""
                    }${showBranchDropdown ? " open_v2" : ""}`}
                    onClick={() => setShowBranchDropdown((prev) => !prev)}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 12,
                        }}
                      >
                        {/* map-pin (lucide) */}
                        <MapPin
                          className={`branch-icon_v2${hasShippingFeeOrEastMalaysia ? " branch-icon-red_v2" : ""}`}
                          aria-hidden="true"
                        />

                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <div className="branch-title_v2">
                            Branch Distribution
                          </div>
                          <div
                            className={`branch-subtitle_v2${hasShippingFeeOrEastMalaysia ? " branch-subtitle-red_v2" : ""}`}
                          >
                            {hasShippingFeeOrEastMalaysia
                              ? "Additional delivery charges applicable"
                              : "Free delivery for all branch locations"}
                          </div>
                        </div>
                      </div>

                      <span style={{ display: "flex" }}>
                        {/* chevron-down (lucide) */}
                        <ChevronDown
                          className={
                            showBranchDropdown
                              ? "rotate_v2 branch-arrow_v2"
                              : "branch-arrow_v2"
                          }
                          aria-hidden="true"
                        />
                      </span>
                    </div>
                  </div>
                  {showBranchDropdown && (
                    <>
                      <div
                        className="branch-dropdown-backdrop_v2"
                        onClick={() => setShowBranchDropdown(false)}
                      />
                      <div
                        className={`branch-custom-dropdown-menu_v2 ${hasShippingFeeOrEastMalaysia ? "has-shipping_v2" : "free-shipping_v2"}`}
                      >
                        <div className="branch-custom-dropdown-inner_v2">
                          {branchOptionsRaw.map((option) => (
                            <div
                              key={option.value}
                              className={`branch-custom-dropdown-item_v2${
                                option.isDisabled ? " is-disabled_v2" : ""
                              }${
                                selectedBranch === option.value
                                  ? " selected_v2"
                                  : ""
                              } ${option.isRed ? "has-shipping-row_v2" : "free-shipping-row_v2"}`}
                              aria-disabled={
                                option.isDisabled ? "true" : undefined
                              }
                              onClick={() =>
                                !option.isDisabled && handleBranchSelect(option)
                              }
                            >
                              {option.label}
                            </div>
                          ))}
                        </div>
                      </div>
                    </>
                  )}
                </div>

                {showCheckoutBranch && selectedBranchData && (
                  <CheckoutBranch
                    branch={selectedBranchData}
                    checkoutData={checkoutData}
                    onClose={() => {
                      setShowCheckoutBranch(false);
                      setSelectedBranch("");
                    }}
                    hasSalesmanId={hasSalesmanId}
                    onSpecialDateChange={handleBranchSpecialDateChange}
                    specialDate={
                      branchSpecialDates[selectedBranchData.branch_code] ?? null
                    }
                    isSpecialDateEnabled={
                      branchSpecialEnabled[selectedBranchData.branch_code] ??
                      false
                    }
                    onToggleSpecialDate={handleBranchSpecialToggle}
                    hasSpecialPoint={
                      String(checkoutData?.special_point) === "1"
                    }
                    isSpecialPointEnabled={
                      branchSpecialPointEnabled?.[
                        selectedBranchData?.branch_code
                      ] ?? false
                    }
                    onToggleSpecialPoint={(code, val) =>
                      setBranchSpecialPointEnabled((prev) => ({
                        ...prev,
                        [code]: val,
                      }))
                    }
                    specialPointData={
                      branchSpecialPointData[selectedBranchData.branch_code] ??
                      null
                    }
                    onSpecialPointChange={(code, data) =>
                      setBranchSpecialPointData((prev) => ({
                        ...prev,
                        [code]: data,
                      }))
                    }
                  />
                )}

                {/* Cart item */}
                <div className="checkout-main_v2">
                  <div className="checkout-orderitems-header_v2">
                    <div className="checkout-section-title_v2">
                      Order Items ({cartData?.cart?.length || 0})
                    </div>
                  </div>
                  {cartData &&
                    cartData.cart &&
                    sortCartItems(cartData.cart).map(
                      (item) => (
                        // Hide the main item when its overlay is open
                        // activeOverlayItemId === item.item_id ? null : (
                        <CartItem
                          key={String(item.id)}
                          item={item}
                          formatCurrency={formatCurrency}
                          activeBranchItemId={activeBranchItemId}
                          setActiveBranchItemId={setActiveBranchItemId}
                          activePromoItemId={activePromoItemId}
                          setActivePromoItemId={setActivePromoItemId}
                        />
                      ),
                      // )
                    )}
                </div>

                {/* Customer P/O Number Field - Only show if user has salesman_id */}
                <div className="checkout-customer-container_v2">
                  <div className="checkout-section-title_v2">
                    Purchase Order Information
                  </div>
                  <div className="checkout-customer-po_v2">
                    <div className="customer-po-label_v2">PO NO.</div>
                    <div className="customer-po-input-container_v2">
                      <span className="customer-po-colon_v2">:</span>
                      <input
                        type="text"
                        className="customer-po-input_v2"
                        placeholder="Enter PO Number"
                        value={customerPO}
                        onChange={(e) => setCustomerPO(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="checkout-customer-po_v2">
                    <div className="customer-po-label_v2">PO Date.</div>
                    <div className="customer-po-input-container_v2">
                      <span className="customer-po-colon_v2">:</span>
                      <div className="po-date-picker-container_v2">
                        <input
                          type="text"
                          className="po-date-range-input_v2"
                          readOnly
                          value={
                            po_date
                              ? new Date(po_date).toLocaleDateString("en-MY", {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                })
                              : ""
                          }
                          placeholder="dd-----yyyy"
                          onClick={() => setCalendarOpen((open) => !open)}
                        />
                        {po_date && (
                          <X
                            className="clear-date_v2"
                            size={16}
                            onClick={(e) => {
                              e.stopPropagation();
                              setCustomerPODate(null);
                            }}
                          />
                        )}

                        <CalendarIcon
                          className="calendar-icon_v2"
                          size={18}
                          onClick={() => setCalendarOpen((open) => !open)}
                        />
                        {calendarOpen && (
                          <div className="calendar_v2">
                            <Calendar
                              onChange={(date) => {
                                setCustomerPODate(date);
                                setCalendarOpen(false);
                              }}
                              value={po_date}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  {hasSalesmanId && (
                    <div className="checkout-shipping-type_v2">
                      <div className="shipping-type-label_v2">
                        Shipping Type
                      </div>
                      <div className="shipping-type-select-container_v2">
                        <span className="shipping-type-colon_v2">:</span>
                        <CustomDropdown
                          options={[
                            ...(checkoutData?.normal_shipping === "1"
                              ? [
                                  {
                                    value: "normal_shipping",
                                    label: "Normal Shipping",
                                  },
                                ]
                              : []),
                            ...(checkoutData?.own_pickup === "1"
                              ? [{ value: "own_pickup", label: "Own Pickup" }]
                              : []),
                            ...(checkoutData?.supplier_to_customer === "1"
                              ? [
                                  {
                                    value: "supplier_to_customer",
                                    label: "Supplier to Customer",
                                  },
                                ]
                              : []),
                          ]}
                          value={shippingType}
                          onChange={(val) => setShippingType(val)}
                          placeholder="Select shipping type"
                          className="checkout-dropdown_v2"
                        />
                      </div>
                    </div>
                  )}

                  <div className="checkout-remark_v2">
                    <div className="remark-label_v2">Remark</div>
                    <div className="remark-input-container_v2">
                      <span className="remark-colon_v2">:</span>
                      <textarea
                        className="remark-input_v2"
                        placeholder="Enter any additional notes or instructions..."
                        value={checkoutMessage}
                        onChange={(e) => setCheckoutMessage(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                {String(checkoutData?.do_status) === "1" && (
                  <div className="checkout-combine-do_v2">
                    <div className="combine-do-header">
                      <div className="combine-do-label_v2">Combine D/O.</div>
                      <div className="combine-do-toggle_v2">
                        <label className="toggle-switch_v2">
                          <input
                            type="checkbox"
                            checked={isCombineDO}
                            onChange={() => setIsCombineDO(!isCombineDO)}
                          />
                          <span className="toggle-slider_v2"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div className="checkout-right_v2">
                <div className="checkout-info_v2">
                  <div className="order-summary-title_v2">Order Summary</div>

                  <div className="co-subtotal-container_v2">
                    <div className="co-subtitle_v2">Payment Term</div>
                    <div className="co-value-container_v2">
                      <div className="co-value_v2" style={{ width: "180px" }}>
                        <div className="co-RM_v2"></div>
                        <div>{checkoutData?.payment_term || "Cash"}</div>
                      </div>
                    </div>
                  </div>

                  <div className="co-subtotal-container_v2">
                    <div className="co-subtitle_v2">Subtotal</div>
                    <div className="co-value-container_v2">
                      <div className="co-value_v2">
                        <div className="co-RM_v2">RM</div>
                        <div>
                          {checkoutData && checkoutData.discount != null
                            ? formatCurrency(checkoutData.subtotal)
                            : "0.00"}
                        </div>
                      </div>
                    </div>
                  </div>
                  {checkoutData && checkoutData.pwp_amount > 0 && (
                    <div className="co-subtotal-container_v2">
                      <div className="co-subtitle_v2">PWP Purchase</div>
                      <div className="co-value-container_v2">
                        <div className="co-value_v2">
                          <div className="co-RM_v2">RM</div>
                          <div>{formatCurrency(checkoutData.pwp_amount)}</div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="co-discount-container_v2">
                    <div className="co-subtitle_v2">Discount</div>
                    <div className="co-value-container_v2">
                      <div className="co-value_v2">
                        <div className="co-RM_v2">-RM</div>
                        <div>
                          {checkoutData && checkoutData.discount != null
                            ? formatCurrency(checkoutData.discount)
                            : "0.00"}
                        </div>
                      </div>
                    </div>
                  </div>
                  {shouldUseTermsDirectly && showFastPayCheckoutBtn && (
                    <div className="co-cashdiscount-container">
                      <div className="co-subtitle">Payment Discount</div>
                      <div className="co-value-container">
                        <div className="co-value">
                          <div className="co-RM">- RM</div>
                          <div>
                            {checkoutData &&
                            checkoutData.fastpayment_discount_total != null
                              ? formatCurrency(
                                  checkoutData.fastpayment_discount_total,
                                )
                              : "0.00"}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="co-shipfee-container_v2">
                    <div className="co-subtitle_v2">Delivery Charges</div>
                    <div className="co-value-container_v2">
                      <div className="co-value_v2">
                        <div className="co-RM_v2">
                          {checkoutData &&
                          checkoutData.total_shipping_cost != null &&
                          Number(checkoutData.total_shipping_cost) > 0
                            ? "RM"
                            : ""}
                        </div>
                        <div>
                          {checkoutData &&
                          checkoutData.total_shipping_cost === 0 ? (
                            <span className="free-text_v2">FREE</span>
                          ) : checkoutData &&
                            checkoutData.total_shipping_cost != null ? (
                            formatCurrency(checkoutData.total_shipping_cost)
                          ) : (
                            "0.00"
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="co-total-sep_v2"></div>
                  <div className="co-total-container_v2">
                    <div className="co-subtitle_v2">Total</div>
                    {/* <div className="co-colon_v2">:</div> */}
                    <div className="co-value-container_v2">
                      <div className="co-value_v2" style={{ width: "150px" }}>
                        <strong>
                          <div className="co-RM_v2">RM</div>
                          <div>
                            {checkoutData && checkoutData.total != null
                              ? formatTotal(
                                  showFastPayCheckoutBtn &&
                                    checkoutData.fastpayment_discount_total
                                    ? checkoutData.total -
                                        checkoutData.fastpayment_discount_total
                                    : checkoutData.total,
                                )
                              : "0.00"}
                          </div>
                        </strong>
                      </div>
                    </div>
                  </div>

                  {/* Cash Payment Method */}
                  <form onSubmit={handleSubmit}>
                    {!shouldUseTermsDirectly && (
                      <div className="co-paymentmethod-container_v2">
                        <div className="co-paymentmethod_v2">
                          <strong>Payment Method</strong>
                        </div>

                        {isStaffPurchase ? (
                          <div className="co-option-box_v2">
                            <div
                              className={`co-option-card_v2 ${
                                selectedPayment === "FPX" ? "selected_v2" : ""
                              }`}
                              onClick={() => handleSelectPayment("FPX")}
                            >
                              <div className="co-radio_v2">
                                <span className="co-radio-outer_v2">
                                  <span className="co-radio-inner_v2"></span>
                                </span>
                              </div>
                              <div className="co-payment-text_v2">
                                <div className="co-payment-title_v2">FPX</div>
                                <div className="co-payment-sub_v2">
                                  Financial Process Exchange
                                </div>
                              </div>
                            </div>
                            {/* <div className="co-optionwithdesc-descrip_v2">
                          After clicking "Proceed to Payment", you will be directed to FPX platform
                        </div> */}
                          </div>
                        ) : (
                          <>
                            <div className="co-option-box_v2">
                              {/* FPX Option */}
                              <div
                                className={`co-option-card_v2 ${
                                  selectedPayment === "FPX" ? "selected_v2" : ""
                                }`}
                                onClick={() => handleSelectPayment("FPX")}
                              >
                                <div className="co-radio_v2">
                                  <span className="co-radio-outer_v2">
                                    <span className="co-radio-inner_v2"></span>
                                  </span>
                                </div>
                                <div className="co-payment-text_v2">
                                  <div className="co-payment-title_v2">FPX</div>
                                  <div className="co-payment-sub_v2">
                                    Financial Process Exchange
                                  </div>
                                </div>
                              </div>
                              {/* <div className="co-option-line_v2"></div> */}
                              {/* Online Banking Option */}
                              <div
                                className={`co-option-card_v2 ${
                                  selectedPayment === "Online Banking"
                                    ? "selected_v2"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleSelectPayment("Online Banking")
                                }
                              >
                                <div className="co-radio_v2">
                                  <span className="co-radio-outer_v2">
                                    <span className="co-radio-inner_v2"></span>
                                  </span>
                                </div>
                                <div className="co-payment-text_v2">
                                  <div className="co-payment-title_v2">IBG</div>
                                  <div className="co-payment-sub_v2">
                                    Interbank GIRO Transfer
                                  </div>
                                </div>
                              </div>
                              {/* <div className="co-optionwithdesc-descrip_v2">
                              After clicking "Proceed to Payment", you will need to upload
                              bank in slip later
                            </div> */}
                            </div>
                          </>
                        )}
                      </div>
                    )}

                    {/* Cash Payment Checkout Button */}
                    {/* {showFastPayCheckoutBtn && (
                  <div className="checkout-button-container">
                    <button
                      className="checkout-button"
                      type="button"
                      disabled={submitting}
                      onClick={handleFastPayNavigate}
                    >
                      {submitting ? "PROCESSING..." : "CHECKOUT"}
                    </button>
                  </div>
                )} */}

                    {/* Default Checkout Button */}
                    {!showFastPayCheckoutBtn && (
                      <div className="checkout-button-container_v2">
                        <button
                          className="checkout-button_v2"
                          type="submit"
                          disabled={
                            submitting ||
                            (!shouldUseTermsDirectly && !selectedPayment)
                          }
                        >
                          {submitting
                            ? "PROCESSING..."
                            : pricingType === "1"
                              ? "Process to Payment"
                              : "Confirm Order"}
                        </button>
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
          {/* E-invoice Modal 独立渲染 */}

          {showCashEinvoicePrompt && (
            <MultiPurpose
              title="E-invoice"
              message={
                <div>
                  Your account is a CASH account. Do you want to fill e-invoice
                  information now?
                </div>
              }
              yesText="Yes"
              noText="No"
              showYesLink={false}
              showNoLink={false}
              onYes={() => {
                setShowEInvoiceModal(true);
                setShowCashEinvoicePrompt(false);
              }}
              onNo={() => {
                // Treat 'No' as user choosing to skip e-invoice for this checkout attempt
                setEinvoiceFilled(true);
                setShowCashEinvoicePrompt(false);
                // continue with submit flow (will use updated einvoiceFilled)
                continueSubmitFlow();
              }}
              onClose={() => setShowCashEinvoicePrompt(false)}
            />
          )}
          {showTinPrompt && (
            <MultiPurpose
              title="Verify TIN"
              yesText="Confirm"
              noText="Cancel"
              showYesLink={false}
              showNoLink={false}
              hideNo={false}
              onYes={() => {
                if (!tinNo || !tinNo.trim()) {
                  setTinError("Please enter TIN number");
                  return;
                }
                setTinError("");
                setShowTinPrompt(false);
                setTinConfirmed(true);
                // proceed with the normal submit flow
                continueSubmitFlow();
              }}
              onNo={() => setShowTinPrompt(false)}
              onClose={() => setShowTinPrompt(false)}
            >
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                <div>Please verify your TIN number. Edit if incorrect.</div>
                <input
                  className="customer-po-input_v2"
                  type="text"
                  value={tinNo}
                  onChange={(e) => setTinNo(e.target.value)}
                  placeholder="Enter TIN number"
                  style={{ padding: 8, width: "100%" }}
                />
                {tinError && (
                  <div style={{ color: "#b71c1c", textAlign: "left" }}>
                    {tinError}
                  </div>
                )}
              </div>
            </MultiPurpose>
          )}
          {showMultiPurpose && (
            <MultiPurpose
              title="Notice"
              message={getMultiPurposeContent()}
              yesText="Pay Now"
              noText="Cancel"
              showYesLink={true}
              yesLink="/myinvoice"
              showNoLink={false}
              hideNo={false}
              onYes={() => {
                setShowMultiPurpose(false);
                navigate("/myinvoice");
              }}
              onNo={() => setShowMultiPurpose(false)}
              onClose={() => setShowMultiPurpose(false)}
            />
          )}
          {showEInvoiceModal && (
            <EInvoiceModal
              onClose={() => setShowEInvoiceModal(false)}
              onConfirm={handleEInvoiceConfirm}
              formData={einvoiceData}
              onChange={(e) =>
                setEinvoiceData({
                  ...einvoiceData,
                  [e.target.name]: e.target.value,
                })
              }
              errors={einvoiceErrors}
              isSubmitting={submitting}
            />
          )}
          {showSalesmanConfirm && (
            <MultiPurpose
              title="Confirm Order"
              message={
                <div>
                  Are you sure you want to place this order on behalf of{" "}
                  <span style={{ color: "#d9534f", fontWeight: 700 }}>
                    {customerName || "this customer"}
                  </span>
                  ?
                </div>
              }
              yesText="Confirm"
              noText="Cancel"
              showYesLink={false}
              showNoLink={false}
              onYes={() => {
                setShowSalesmanConfirm(false);
                if (selectedPayment === "FPX") {
                  const confirmSalesmanOpt = hasSalesmanId
                    ? {
                        staff_id_val: selectedStaffId,
                        staff_name_val: selectedStaffName,
                        customer_po_val: customerPO,
                        customer_do_val: isCombineDO ? "1" : "0",
                        ordered_by: salesmanId,
                      }
                    : null;
                  const confirmOption =
                    hasSalesmanId && checkoutData.items_by_branch?.length > 0
                      ? checkoutData.items_by_branch.map((branch) => ({
                          branch_id: branch.branch_id,
                          stc: shippingType === "supplier_to_customer" ? 1 : 0,
                          own_delivery: shippingType === "own_pickup" ? 1 : 0,
                          special_point: branchSpecialPointData[
                            branch.branch_code
                          ]
                            ? 1
                            : 0,
                          special_date: branchSpecialDates[branch.branch_code]
                            ? 1
                            : 0,
                          special_date_info: branchSpecialDates[
                            branch.branch_code
                          ]
                            ? new Date(branchSpecialDates[branch.branch_code])
                                .toLocaleDateString("en-MY")
                                .split("/")
                                .reverse()
                                .join("-")
                            : "",
                          no_shipping: 0,
                          special_point_addr: {
                            name:
                              branchSpecialPointData[branch.branch_code]
                                ?.sp_name || "",
                            phone:
                              branchSpecialPointData[branch.branch_code]
                                ?.sp_phone || "",
                            addr:
                              branchSpecialPointData[branch.branch_code]
                                ?.sp_addr || "",
                            state:
                              branchSpecialPointData[branch.branch_code]
                                ?.sp_state || "",
                            city:
                              branchSpecialPointData[branch.branch_code]
                                ?.sp_city || "",
                            postcode:
                              branchSpecialPointData[branch.branch_code]
                                ?.sp_postcode || "",
                          },
                        }))
                      : null;
                  navigate(`/uploadcheque?cart_ids=${selectedItems}&type=fpx`, {
                    state: {
                      selectedItems,
                      paymentType: "fpx",
                      pricingType: tabParam,
                      checkoutMessage,
                      customerPO,
                      specifiedShippingDate: isShippingDateSpecified
                        ? specifiedShippingDate
                        : null,
                      ...(confirmSalesmanOpt && {
                        salesmanOpt: confirmSalesmanOpt,
                      }),
                      ...(confirmOption && { option: confirmOption }),
                      ...(einvoiceFilled && {
                        extraEinvoiceData: einvoiceData,
                      }),
                    },
                  });
                } else {
                  doCheckout(einvoiceFilled ? einvoiceData : null);
                }
              }}
              onNo={() => setShowSalesmanConfirm(false)}
              onClose={() => setShowSalesmanConfirm(false)}
            />
          )}

          {showSpError && (
            <MultiPurpose
              title="Special Point Incomplete"
              message={<div>{spErrorMsg}</div>}
              yesText="OK"
              hideNo={true}
              showYesLink={false}
              showNoLink={false}
              onYes={() => {
                setShowSpError(false);
                setSubmitting(false);
              }}
              onClose={() => {
                setShowSpError(false);
                setSubmitting(false);
              }}
            />
          )}

          {showSupplierError && (
            <MultiPurpose
              title="Different Suppliers"
              message={<div>{supplierErrorMsg}</div>}
              yesText="OK"
              hideNo={true}
              showYesLink={false}
              showNoLink={false}
              onYes={() => {
                setShowSupplierError(false);
                setSubmitting(false);
              }}
              onClose={() => {
                setShowSupplierError(false);
                setSubmitting(false);
              }}
            />
          )}

          {showCheckoutError && (
            <MultiPurpose
              title="Checkout Failed"
              message={<div>{checkoutErrorMsg}</div>}
              yesText="OK"
              hideNo={true}
              showYesLink={false}
              showNoLink={false}
              onYes={() => setShowCheckoutError(false)}
              onClose={() => setShowCheckoutError(false)}
            />
          )}
        </div>
      )}
    </>
  );
};

export default Checkoutv2;
